import styled from 'styled-components'

export default styled.div`
  font-size: 24px;
  color: #101010;
  line-height: 32px;
`
